import React from 'react';
import { useLottieRef } from '../../controllers/use-lottie-ref/index.tsx';
import { businessIntroData } from './assets/business-intro.tsx';

export const BusinessIntroAnimation = () => {
	const { lottieRef } = useLottieRef(businessIntroData);
	return <div aria-hidden ref={lottieRef} />;
};

export default BusinessIntroAnimation;
